import * as React from 'react';
import { Button, Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import { Field, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { isEmail, isRequired } from '../../../../../../util/validators';

interface IForgottenPasswordFormProps extends InjectedFormProps {
  actions: {
    push: (route: string) => void;
  };
}

class ForgottenPasswordForm extends React.Component<IForgottenPasswordFormProps> {
  public render() {
    const { handleSubmit, valid, submitting } = this.props;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div>
          <div>
            <FormGroup controlId="email">
              <Col componentClass={ControlLabel} sm={6}>
                Email
              </Col>
              <Col sm={6}>
                <Field
                  name={'email'}
                  type="email"
                  autoComplete="new-password"
                  component={FieldFormControl}
                  validate={[isRequired, isEmail]}
                />
              </Col>
            </FormGroup>
          </div>
        </div>
        <div className="mt-30" style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            bsStyle="primary"
            type="submit"
            bsSize="small"
            disabled={submitting || !valid}
            className="pull-right medium-width secondary-button">
            RESET PASSWORD
          </Button>
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'forgotten_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('forgotten_password');

    return component;
  },
  connect(
    (dispatch) => ({
      actions: {
        dispatch,
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(ForgottenPasswordForm);
